import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const Service = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yImage = useTransform(scrollYProgress, [0, 1], ['0%', '10%']);
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '-10%']);
  const points = ['une évaluation complète du tatouage et de la peau', 'un plan de traitement personnalisé', "l'utilisation du laser picoseconde et du Q-Switched", 'un suivi rigoureux pour soutenir la cicatrisation', 'plus de 100 avis 5 étoiles sur Google'];
  return <section ref={ref} id="service" className="py-24 md:py-32 lg:py-48 bg-brand-light overflow-hidden" data-id="element-166">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-167">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-24" data-id="element-168">
          {/* Dominant Image Content (Left) */}
          <motion.div style={{
          y: yImage
        }} className="w-full lg:w-[55%] relative h-[50vh] md:h-[60vh] lg:h-[85vh]" data-id="element-169">
            <ScrollReveal clipReveal="left" duration={1.5} className="h-full w-full" data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/6GJuifRG6rMSVwanEvq8DR/owner.jpg" alt="Portrait du praticien spécialiste en détatouage laser chez Dispel Your Tattoo à Martigny" className="w-full h-full object-cover grayscale-[20%]" loading="lazy" data-id="element-171" />
            </ScrollReveal>
          </motion.div>

          {/* Text Content (Right) */}
          <motion.div style={{
          y: yText
        }} className="w-full lg:w-[45%]" data-id="element-172">
            <ScrollReveal blur scale duration={1.2} data-id="element-173">
              <h2 className="text-4xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-brand-dark mb-6 md:mb-8 tracking-tight leading-[1.2] text-balance" data-id="element-174">
                Service de Détatouage en Valais
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={0.2} blur data-id="element-175">
              <h3 className="text-lg md:text-xl lg:text-2xl font-medium text-brand-dark/70 mb-10 md:mb-14 tracking-tight" data-id="element-176">
                Un Espace Entièrement Consacré au Laser
              </h3>
            </ScrollReveal>

            <div className="space-y-6 md:space-y-8 mb-12 md:mb-16" data-id="element-177">
              {points.map((point, index) => <div key={index} className="flex items-start space-x-4 md:space-x-6" data-id="element-178">
                  <motion.div initial={{
                scaleX: 0
              }} whileInView={{
                scaleX: 1
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                duration: 0.8,
                delay: 0.3 + index * 0.1,
                ease: [0.16, 1, 0.3, 1]
              }} className="w-6 md:w-8 h-[1px] bg-brand-dark/30 mt-2.5 md:mt-3 shrink-0 origin-left" data-id="element-179" />
                  <ScrollReveal delay={0.4 + index * 0.1} blur direction="none" distance={0} data-id="element-180">
                    <p className="text-base md:text-lg lg:text-xl text-brand-dark font-light leading-snug" data-id="element-181">
                      {point}
                    </p>
                  </ScrollReveal>
                </div>)}
            </div>

            <div className="py-16 md:py-24 mt-8 md:mt-12" data-id="element-182">
              <figure className="relative" data-id="element-183">
                <span className="absolute -top-10 -left-2 md:-top-16 md:-left-6 text-[6rem] md:text-[10rem] leading-none text-brand-dark/10 font-serif select-none pointer-events-none" aria-hidden="true" data-id="element-184">
                  «
                </span>
                <ScrollReveal delay={0.6} blur data-id="element-185">
                  <blockquote className="relative z-10" data-id="element-186">
                    <p className="text-2xl md:text-3xl text-brand-dark font-light italic leading-[1.6] tracking-tight" data-id="element-187">
                      Que vous souhaitiez éclaircir un tatouage pour un cover-up ou
                      l'effacer totalement, vous recevrez un accompagnement clair,
                      honnête et adapté à vos objectifs.
                    </p>
                  </blockquote>
                </ScrollReveal>
                <ScrollReveal delay={0.9} blur direction="none" distance={0} data-id="element-188">
                  <figcaption className="mt-8 md:mt-10 flex items-center space-x-4" data-id="element-189">
                    <div className="w-6 md:w-8 h-[1px] bg-brand-dark/30 shrink-0" data-id="element-190" />
                    <span className="text-xs md:text-sm font-medium text-brand-dark tracking-[0.2em] uppercase" data-id="element-191">
                      Marc
                    </span>
                  </figcaption>
                </ScrollReveal>
              </figure>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};